module.exports = __webpack_public_path__ + "dd95686a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/add_image@2x.png
// module id = 1022
// module chunks = 0